import React, { useState, MouseEvent } from "react";
import { Box, Button, Typography, Menu, MenuItem } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Version } from "../../../types/version";
import ContributorTable from "../../../components/tables/ContributorTable";
import {
  ContributorConnection,
  SystemContributorTypes,
  SYSTEM_CONTRIBUTION_TYPES_LABELS,
} from "../../../types/contributor";
import useContributorConnectionController from "../../../controllers/connections/ContributorConnectionController";

interface ContributorSectionProps {
  anchor: Version;
  systemLanguageType: ContributorConnection["system_language_type"];
}

const ContributorSection: React.FC<ContributorSectionProps> = ({
  anchor,
  systemLanguageType,
}) => {
  const [selectedType, setSelectedType] = useState<SystemContributorTypes>(
    SystemContributorTypes.TRANSLATOR
  );

  const controller = useContributorConnectionController({
    from: anchor,
    contributorType: selectedType,
    systemLanguageType,
  });

  const { openCreateDialog } = controller;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = (e: MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);
  const closeMenu = () => setAnchorEl(null);

  const handleSelect = (type: SystemContributorTypes) => {
    setSelectedType(type);
    closeMenu();
    openCreateDialog();
  };

  return (
    <Box sx={{ width: "100%", mb: 4 }}>
      <Box sx={{ position: "relative", mb: 2, textAlign: "center" }}>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={openMenu}
          sx={{ position: "absolute", left: 16 }}
        >
          New Contributor
        </Button>
        <Typography variant="h2">Contributors</Typography>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
          {Object.values(SystemContributorTypes).map((type) => (
            <MenuItem key={type} onClick={() => handleSelect(type)}>
              {SYSTEM_CONTRIBUTION_TYPES_LABELS[type]}
            </MenuItem>
          ))}
        </Menu>
      </Box>

      <ContributorTable
        controller={controller}
        contributorType={selectedType}
        systemLanguageType={systemLanguageType}
      />
    </Box>
  );
};

export default ContributorSection;
